import request from "@/utils/request";
// 获取大概首页信息
export function getCompetitionHomeInfo(data){
    return request({
        url:'/getCompetitionHomeInfo',
        data:data,
        method:'get'
    })
}

// 发布帖子
export function newPost(data){
    return request({
        url:'/web/newPost',
        data:data,
        method:'post'
    })
}
// 查看帖子列表 登录
export function getPosts(data){
    return request({
        url:'/web/getPosts',
        data:data,
        method:'get'
    })
}
// 版主：查看帖子以及评论，所有的
export function getPostsByAdmin(data){
    return request({
        url:'/web/getPostsByAdmin',
        data:data,
        method:'get'
    })
}
// 查看帖子列表 未登录
export function getPostDetailByGuest(data){
    return request({
        url:'/getPostDetailByGuest',
        data:data,
        method:'get'
    })
}
// 获取详情
export function getPostDetail(data){
    return request({
        url:'/web/getPostDetail',
        data:data,
        method:'get'
    })
}
// 获取详情 - 未登录
export function getPostsByGuest(data){
    return request({
        url:'/getPostsByGuest',
        data:data,
        method:'get'
    })
}
// 审批状态
export function updatePostStatus(data){
    return request({
        url:'/web/updatePostStatus',
        data:data,
        method:'post'
    })
}

// 大概酒店预定
export function newHotelReservation(data){
    return request({
        url:'/newHotelReservation',
        data:data,
        method:'post'
    })
}
